module.exports = __webpack_public_path__ + "static/media/Orientamento_sapernedipiù.eab6a813.png";